import { SavedFilters } from '../SavedFilters';
import { Dashboard } from './Dashboard';

export const SavedFiltersPage = () => (
  <Dashboard openLogIn>
    <SavedFilters />
  </Dashboard>
);
